import React from "react";
import api from "../../api/http";
import { API_ENDPOINTS } from "../../api/endpoints";
import { useLanguage } from "../../context/LanguageContext";
import ModalShell from "./ModalShell";
import BillingProfileForm, { EMPTY_PROFILE } from "./BillingProfileForm";

/**
 * Asks for the billing name/address before an invoice is issued, so invoices
 * are never addressed to the signup placeholder ("Trial Company").
 */
export default function BillingProfileModal({ onSaved, onClose, submitLabel }) {
  const { text } = useLanguage();
  const [initial, setInitial] = React.useState(null);

  React.useEffect(() => {
    let active = true;
    api.get(API_ENDPOINTS.BILLING_PROFILE)
      .then((res) => { if (active) setInitial({ ...EMPTY_PROFILE, ...(res.data?.data || {}) }); })
      .catch(() => { if (active) setInitial({ ...EMPTY_PROFILE }); });
    return () => { active = false; };
  }, []);

  const save = async (profile) => {
    const res = await api.put(API_ENDPOINTS.BILLING_PROFILE, profile);
    await onSaved(res.data?.data || profile);
  };

  return (
    <ModalShell
      title={text("請求先情報の入力", "Billing information")}
      description={text(
        "請求書の宛名・住所に使用します。請求書を発行する前にご入力ください。",
        "Used as the name and address on your invoices. Please enter it before we issue an invoice."
      )}
      onClose={onClose}
      labelledBy="billing-profile-title"
    >
      {initial ? (
        <BillingProfileForm
          initialValues={initial}
          submitLabel={submitLabel || text("保存して続ける", "Save and continue")}
          onSubmit={save}
          onCancel={onClose}
        />
      ) : (
        <p style={{ color: "#6b7280" }}>{text("読み込み中…", "Loading…")}</p>
      )}
    </ModalShell>
  );
}
